module.exports = __webpack_public_path__ + "static/popup_SP@2x-min-d7af58155115e8c45cc64598b6573cc9.png";